
import { types } from '../types';
import { createAction, createReducer } from '@reduxjs/toolkit';

// export const getDeviceTypeList = () => {
//   return {
//     type: types.GET_DEVICETYPE
//   };
// };

// export const getDeviceTypeListSuccess = (deviceTypeList) => {
//   return {
//     type: types.GET_DEVICETYPE_SUCCESS,
//     deviceTypeList
//   };
// };

// export const saveDeviceType = (payload) => {
//   return {
//     type: types.SAVE_DEVICETYPE,
//     payload
//   };
// };

// export const updateDeviceType = (payload) => {
//   return {
//     type: types.UPDATE_DEVICETYPE,
//     payload
//   };
// };

// export const saveDeviceParamters = (payload) => {
//   return {
//     type: types.SAVE_DEVICEPARAMETERS,
//     payload
//   };
// };

// export const deleteDeviceParameters = (payload) => {
//   return {
//     type: types.DELETE_DEVICEPARAMETERS,
//     payload
//   };
// };

// export const getDeviceTypeListCM = () => {
//   return {
//     type: types.GET_DEVICETYPE_CM
//   };
// };

// export const getDeviceTypeCMListSuccess = (deviceTypeList) => {
//   return {
//     type: types.GET_DEVICETYPE_CM_SUCCESS,
//     deviceTypeList
//   };
// };

// export const deleteDeviceType = (deviceTypeID) => {
//   return {
//     type: types.DELETE_DEVICETYPE,
//     deviceTypeID
//   };
// };



const deviceTypeList = createAction(types.GET_DEVICETYPE_SUCCESS);
const deviceTypeCMList = createAction(types.GET_DEVICETYPE_CM);



const initialState = { 
  deviceTypeList: [],
  deviceTypeCMList: []
};




const DeviceTypeReducer = createReducer (initialState, (builder) => {
  builder
  .addCase(deviceTypeList, (state,action) => {
    state.deviceTypeList = action.deviceTypeList;
  })
  .addCase(deviceTypeCMList, (state,action) => {
    state.deviceTypeCMList = action.deviceTypeList;
  })
  .addDefaultCase(() => {});
});

export default DeviceTypeReducer;
